var map = {
	"./baobiao.svg": 8833,
	"./baobiao_1.svg": 1421,
	"./clash.svg": 2423,
	"./cywz.svg": 8739,
	"./fahuo.svg": 4985,
	"./id.svg": 1347,
	"./logo.svg": 5129,
	"./rc.svg": 5153,
	"./shaperight.svg": 4651,
	"./shouye.svg": 3191,
	"./textsearch.svg": 6249,
	"./tongzhi.svg": 5953,
	"./zhankai.svg": 8604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6047;